import React from 'react'

import SummaryGoogleImage from './SummaryGoogleImage'

import ModalImageThumbnail from 'LuxKit/Modal/ModalImageThumbnail'
import { Place } from 'tripPlanner/types/common'

type Props = {
  place: Place
  tripId: string
  tripItemId: string
  offer?: App.AnyOffer
  placeholder?: React.ReactNode
}

const imageParams = {
  sm: '21:9',
  smWidth: '480px',
  md: '21:9',
  mdWidth: '720px',
  quality: 'good' as const,
}

function SummaryImage({
  place,
  tripId,
  tripItemId,
  offer,
  placeholder = null,
}: Props) {
  if (offer && (offer as App.Offer).image) {
    return (
      <ModalImageThumbnail
        imageParams={imageParams}
        image={(offer as App.Offer).image}
      />
    )
  }
  if (place && 'id' in place && place.id) {
    return (
      <SummaryGoogleImage
        placeId={place.id}
        title={place.name}
        maxWidth={640}
        tripId={tripId}
        tripItemId={tripItemId}
      />
    )
  }
  return <>{placeholder}</>
}

export default SummaryImage
